import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=35908766&scoped=true&"
import script from "./paginate.vue?vue&type=script&lang=ts&"
export * from "./paginate.vue?vue&type=script&lang=ts&"
import style0 from "./paginate.vue?vue&type=style&index=0&id=35908766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35908766",
  null
  
)

export default component.exports